import { AfterContentInit, ContentChildren, Directive, Input, OnChanges, QueryList } from '@angular/core';
import { ToggleColumnDirective } from '../toggle-column/toggle-column.directive';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[toggleTable]',
})
export class ToggleTableDirective implements OnChanges, AfterContentInit {
  @ContentChildren(ToggleColumnDirective, { descendants: true }) public body: QueryList<ToggleColumnDirective>;

  @Input('toggleTable') public toggeTable: { value: string }[] = [];

  constructor() {}

  private toggleColumns(): void {
    if (this.body) {
      this.body.forEach(elem => {
        if (elem.toggleColumn && (!this.toggeTable.find(col => col.value === elem.toggleColumn))) {
          elem.hide();
        } 
        else {
          elem.show();
        }
      });
    }
  }

  public ngAfterContentInit(): void {
    this.toggleColumns();
  }

  public ngOnChanges(): void {
    this.toggleColumns();
  }
}
